import React from "react";
import { MessageCircleIcon } from "lucide-react";
import { CONTACT } from "../data/mccContent";
type WhatsAppLineProps = {
  label: string;
  context: string;
  className?: string;
};
export function WhatsAppLine({
  label,
  context,
  className = ""
}: WhatsAppLineProps) {
  const href = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(`Hello MCC, I am interested in ${context} and would like to know more.`)}`;
  function trackEvent() {
    window.dispatchEvent(new CustomEvent("mcc:conversion", {
      detail: {
        eventName: "whatsapp_contextual_click",
        context
      }
    }));
  }
  return <a href={href} target="_blank" rel="noreferrer" onClick={trackEvent} className={`inline-flex items-center gap-2 border-b border-current pb-1 text-sm font-semibold transition-colors duration-200 hover:text-[#bb1e35] ${className}`} data-id="element-447" data-mp="3mknbz2e6u7qs">
      <MessageCircleIcon size={16} data-id="element-448" data-mp="e5vg9jqocx4n" /> {label}
    </a>;
}